import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import AdminNodes from './admin/AdminNodes'
import AdminUsers from './admin/AdminUsers'
import AdminShares from './admin/AdminShares'
import AdminAudit from './admin/AdminAudit'

export default function Admin() {
  return (
    <div className="pad">
      <h1>관리</h1>
      <nav className="tabs">
        <NavLink to="/admin/nodes">노드</NavLink>
        <NavLink to="/admin/users">사용자</NavLink>
        <NavLink to="/admin/shares">공유 폴더</NavLink>
        <NavLink to="/admin/audit">기록</NavLink>
      </nav>

      <Routes>
        <Route index element={<Navigate to="/admin/nodes" replace />} />
        <Route path="nodes" element={<AdminNodes />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="shares" element={<AdminShares />} />
        <Route path="audit" element={<AdminAudit />} />
      </Routes>
    </div>
  )
}
